import type { PersonProfile } from "@sales-ops-amplify/shared";

export function PersonEnrichmentTab({
  profile,
  onEnrich,
  enriching,
}: {
  profile: PersonProfile;
  onEnrich?: () => void;
  enriching?: boolean;
}) {
  const user = profile.user;
  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4">
      <h3 className="text-sm font-semibold">Enrichment status</h3>
      <dl className="grid gap-3 sm:grid-cols-2 text-sm">
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Overall
          </dt>
          <dd className="font-medium">
            {user?.enrichmentStatus ?? "unknown"}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Last enriched
          </dt>
          <dd className="font-medium">
            {user?.lastEnrichedAt
              ? new Date(user.lastEnrichedAt).toLocaleString()
              : "—"}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Email status
          </dt>
          <dd className="font-medium">
            {profile.emailStatus ?? user?.emailStatus ?? "—"}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Phone status
          </dt>
          <dd className="font-medium">
            {profile.phoneStatus ?? user?.phoneStatus ?? "—"}
          </dd>
        </div>
      </dl>
      {onEnrich ? (
        <button
          type="button"
          disabled={enriching}
          onClick={onEnrich}
          className="rounded-md bg-brand px-3 py-2 text-xs font-semibold text-brand-foreground disabled:opacity-50"
        >
          {enriching ? "Enriching…" : "Enrich contact"}
        </button>
      ) : null}
    </div>
  );
}
